<template>
  <div>
    <div class="page-header clear-filter" filter-color="black3">
      <parallax
        v-bind:useScroll="false"
        class="page-header-image"
        style="background-image:url('/img/img_map.png')"
      ></parallax>
      <div class="map-area">
        <div class="map-title">
          <h6 class="card-title mb-4">Zone #{{currentZone}}</h6>
        </div>
        <!-- <div class="map-title2">
          <h6 class="card-title mb-4" style="color: white;">{{$t('Dev. Rank')}}</h6>
        </div> -->
        <!-- <div class="map-title-devrank">
              <b-form-checkbox id="checkbox1" v-model="visibleDevRank" value="on" unchecked-value="off">{{$t('map_devrank')}}</b-form-checkbox>
        </div>-->
        <div class="map-scroll-stage">
          <!-- <map-layer ref="mapLayer" :viewport="viewport" v-bind:columnCount=32 v-bind:rowCount=32 v-bind:tileWidth=25 v-bind:tileHeight=25></map-layer> -->
          <grid-layer
            :viewport="viewport"
            :visible="showGridChecked"
            v-bind:visibleDevRank="visibleDevRank"
            v-bind:onSale="true"
            v-if="renderGrid"
            v-bind:mapType="1"
            v-bind:selectedId="selectedId"
          ></grid-layer>
        </div>
      </div>
      <div class="minimap-area">
        <!-- <div class="minimap-title">
                <h5 class="card-title mb-4">World Map</h5>
        </div>-->
        <div class="minimap-scroll-stage">
          <!-- <map-layer ref="mapLayer" :viewport="viewport" v-bind:columnCount=8 v-bind:rowCount=8 v-bind:tileWidth=40 v-bind:tileHeight=40></map-layer> -->
          <grid-layer
            :viewport="viewport"
            :visible="showGridChecked"
            v-if="renderGrid"
            v-bind:onSale="true"
            v-bind:columnCount="8"
            v-bind:rowCount="8"
            v-bind:tileWidth="40"
            v-bind:tileHeight="40"
            v-bind:mapType="0"
          ></grid-layer>
        </div>
      </div>
      <div class="gamemap-area" v-if="selectedLandId != 0">
        <div class="gamemap-title">
          <h6 class="card-title mb-4">{{$t('Game Field')}}</h6>
        </div>
        <div class="gamemap-scroll-area">
          <div v-for="object in trees" v-bind:key="object._id">
            <div
              v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'40px', height:'40px'}"
            >
              <img v-bind:src="`/img/Tiles/fo_${object.code}.png`" width="100%" />
            </div>
          </div>
          <div v-for="object in objects" v-bind:key="object._id">
            <div
              v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'40px', height:'40px'}"
            >
              <img
                v-if="object.display != null"
                v-bind:src="`/img/object_${object.display}.png`"
                width="100%"
              />
              <h5
                v-if="object.display != null"
                style="width:100%; height: 100%; text-align: center; margin-top: -13px; color: white; font-size: 0.7em;"
              >Lv.{{object.level}}</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="map-info-area">
        <table style="width: 100%; margin-top: 0px;">
          <tr style="height: 27px;">
            <td style="width: 100%;" colspan="2">
              <h6 class="card-title2" style="text-align: center;">{{$t('map_desc_title')}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 20%;">
              <h6 class="card-title2">1.</h6>
            </td>
            <td style="width: 80%;">
              <h6 class="card-title3" style="text-align: left; text-transform: none;">{{$t('map_desc2')}}</h6>
            </td>
          </tr>
          <tr style="height: 56px;">
            <td style="width: 20%;">
              <h6 class="card-title2">2.</h6>
            </td>
            <td style="width: 80%;">
              <h6 class="card-title3" style="text-align: left; text-transform: none;">{{$t('map_desc1')}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 20%;">
              <h6 class="card-title2">3.</h6>
            </td>
            <td style="width: 80%;">
              <h6 class="card-title3" style="text-align: left; text-transform: none;">{{$t('map_desc3')}}</h6>
            </td>
          </tr>
          <tr style="height: 32px;">
            <td style="width: 100%;" colspan="2">
              <h6 class="card-title2" style="text-align: center;">{{$t('map_feature_title')}}</h6>
            </td>
          </tr>
          <tr style="height: 32px;">
            <td style="width: 100%;" colspan="2">
              <h6 class="card-title2" style="text-align: left; text-transform: none; margin-bottom: 0px;">{{$t('map_feature_level')}}</h6>
            </td>
          </tr>
          <tr style="height: 32px;">
            <td style="width: 100%;" colspan="2">
              <h6 class="card-title2" style="text-align: left; text-transform: none; margin-bottom: 0px;">{{$t('map_feature_owner')}}</h6>
            </td>
          </tr>
          <tr style="height: 32px;">
            <td style="width: 100%;" colspan="2">
              <h6 class="card-title2" style="text-align: left; text-transform: none; margin-bottom: 0px;">{{$t('map_feature_reward1')}}</h6>
            </td>
          </tr>
          <tr style="height: 32px;">
            <td style="width: 100%;" colspan="2">
              <h6 class="card-title2" style="text-align: left; text-transform: none; margin-bottom: 0px;">{{$t('map_feature_reward2')}}</h6>
            </td>
          </tr>
        </table>
      </div>
      <div class="land-info-area" v-if="selectedLandId != 0">
        <div class="land-info-title">
          <h6 class="card-title mb-4">{{$t('Land')}} #{{landInfo.landId}}</h6>
        </div>
        <table style="width: 100%; margin-top: 20px;">
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Dev. Rank')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.devRank}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Name')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.landName}}</h6>
            </td>
          </tr>
          <tr style="height: 56px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Owner')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3" v-if="landInfo.owner != null">
                <a
                  v-bind:href="getEtherScanUrl(landInfo.owner.address)"
                  target="_blank"
                >{{landInfo.owner.address}}</a>
              </h6>
              <h6 class="card-title3" v-if="landInfo.owner == null">{{$t('not_own')}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Comment')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.profile.comment}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Color')}}</h6>
            </td>
            <td style="width: 70%;">
              <div
                v-bind:style="{width: `24px`, height: `24px`, 'border': '1px solid #000000', 'background-color': `${this.getHexColor(landInfo.attributes.profile.color)}`, 'margin-left':`auto`, 'margin-right':0, 'margin-top':'-10px'}"
              ></div>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Reward')}}</h6>
            </td>
            <td style="width: 70%;"></td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Cumulative')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.stats.token}}DAI</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Unclaimed')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.storage.token}}DAI</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Resources')}}</h6>
            </td>
            <td style="width: 70%;"></td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Cumulative')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.stats.resources}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Unclaimed')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.storage.resources}}</h6>
            </td>
          </tr>
        </table>
        <div style="position: absolute; bottom: 35px; left: 0px; width: 100%; height: 80px;">
          <table style="width: 100%; height: 100%;">
            <tr>
              <td style="width: 100%; text-align: center; color: #00ff00;">
                Location {{getLocation(landInfo.landId)}}
              </td>
            </tr>
            <tr>
              <!-- <td style="width: 50%; text-align: center;">
                  <div
                  style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;"
                  class="btn"
                >{{$t('Add to cart')}}</div>
              </td>-->
              <!-- <td style="width: 100%; text-align: center;">
                  <div
                  @click="goToLandPage()"
                  style="width: 270px; height: 68px; background-image: url('/img/btn_270.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;"
                  class="btn"
                >{{$t('Details')}}</div>
              </td>-->
              <td style="width: 100%; text-align: center;">
                <div
                  style="width: 270px; height: 68px; background-image: url('/img/btn_270.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;"
                  class="btn"
                  v-clipboard:copy="landUrl"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >{{$t(`Copy`)}}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax, Button } from "@/components";
import axios from "axios";
import config from "../config.js";
// import MapLayer from '../components/partials/MapLayer.vue';
import GridLayer from "../components/partials/GridLayer.vue";

const HIDE_GRID_WHEN_SCROLLING = true;
export default {
  name: "Map",
  components: {
    // MapLayer,
    GridLayer,
    Parallax,
    [Button.name]: Button
  },
  data: () => ({
    viewport: {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    },
    landUrl: "",
    isScrolling: false,
    scrollingTimer: null,
    mousedownFlag: false,
    mousedownOffset: null,
    showGridChecked: true,
    visibleDevRank: "off",
    selectedLandId: 0,
    landInfo: {},
    objects: [],
    trees: []
  }),
  computed: {
    currentLandId() {
      return this.$store.state.area.selectedLand;
    },
    currentZone() {
      return this.$store.state.map.currentZone;
    },
    renderGrid() {
      return !HIDE_GRID_WHEN_SCROLLING || !this.isScrolling;
    },
    selectedId() {
      let landId = this.$route.params.landId;
      if (landId == null) {
        return 0;
      }
      return parseInt(landId);
    }
  },
  mounted() {
    let landId = this.$route.params.landId;
    if (landId != null) {
      this.changeLandId(landId);
    }

    this.$nextTick(() => {});
  },
  watch: {
    "$route.params.landId": function(landId) {
      this.changeLandId(landId);
    },
    async currentLandId(val) {
      const treeCodes = [501, 502, 503, 504, 505, 601, 602, 603];
      this.trees = [];
      for (let i = 0; i < 10; ++i) {
        this.trees.push({
          _id: i,
          code: treeCodes[Math.floor(Math.random() * treeCodes.length)],
          x: Math.floor(Math.random() * 8) * 40,
          y: Math.floor(Math.random() * 8) * 40
        });
      }
      this.landUrl = `${config.web.url}/map/${val[0]}`;
      this.landInfo = await this.getLandInfo(val[0]);
      this.objects = await this.getFieldObjects(val[0]);
      this.selectedLandId = this.landInfo.landId;
    }
  },
  methods: {
    changeLandId: async function(landId) {
      if (landId != null) {
        landId = parseInt(landId);
        if (landId >= 100000 && landId <= 165535) {
          this.landUrl = `${config.web.url}/map/${landId}`;

          let currentLandId = landId;
          landId = landId % 100000;
          let landX = landId % 256;
          let landY = 255 - Math.floor(landId / 256);
          landX = Math.floor(landX / 32);
          landY = Math.floor(landY / 32);
          let zoneIdx = landY * 8 + landX;

          let zoneId = this.$store.state.map.zoneMap[zoneIdx];
          this.$store.commit("clickWorldMap", {
            key: zoneId
          });
          this.$store.commit("setSelectedLandId", currentLandId);
        }
      }
    },
    getLocation: function(landId) {
      let zoneY = Math.floor((landId - 100000) / 256);
      let zoneX = (landId - 100000) % 256;
      let x1 = zoneX * 8;
      let y1 = zoneY * 8;
      let x2 = zoneX * 8 + 7;
      let y2 = zoneY * 8 + 7;
      return `[${x1},${y1}] ~ [${x2},${y2}]`;
    },
    goToLandPage: function() {
      //this.$router.push(`/land/${this.selectedLandId}`)
      window.open(`${config.web.url}/land/${this.selectedLandId}`, "_blank");
    },
    getEtherScanUrl: function(address) {
      return `${config.etherscan.account}/${address}`;
    },
    getHexColor: function(number) {
      return "#" + (number >>> 0).toString(16).slice(-6);
    },
    getLandInfo: function(landId) {
      console.log("getLandInfo - ", landId);
      return new Promise((resolve, reject) => {
        axios
          .get(`${config.api.game_url}/land/info?landId=${landId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              resolve(ret.data.land);
            } else {
              reject();
            }
          });
      });
    },
    getFieldObjects: function(landId) {
      console.log("getFieldObjects - ", landId);
      return new Promise((resolve, reject) => {
        axios
          .get(`${config.api.game_url}/field/fieldobjects?landId=${landId}`, {})
          .then(ret => {
            if (ret.data.result == true) {
              let objects = ret.data.objects;
              landId = landId % 100000;
              let landX = landId % 256;
              let landY = Math.floor(landId / 256);
              let x = landX * 8;
              let y = landY * 8;
              for (let i = 0; i < objects.length; ++i) {
                objects[i].x = (objects[i].loc[1] - x) * 40 - 10;
                objects[i].y = (7 - (objects[i].loc[2] - y)) * 40;
                if (
                  objects[i].code >= 20100101 &&
                  objects[i].code <= 20100104
                ) {
                  objects[i].display = objects[i].code - 20100100;
                } else if (
                  objects[i].code >= 20200101 &&
                  objects[i].code <= 20200103
                ) {
                  objects[i].display = objects[i].code - 20200100 + 4;
                } else if (objects[i].code == 20200201) {
                  objects[i].display = 8;
                }
              }
              resolve(objects);
            } else {
              reject();
            }
          });
      });
    },
    onMousedown(e) {
      this.mousedownFlag = true;
      this.mousedownOffset = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.isDragging = false;
    },
    onMousemove(e) {
      if (!this.mousedownFlag) {
        return;
      }
      if (this.isDragging) {
        this.adjustViewportPosition(
          -e.originalEvent.movementX,
          -e.originalEvent.movementY,
          1
        );
      } else if (
        Math.abs(this.mousedownOffset.x - e.offsetX) +
          Math.abs(this.mousedownOffset.y - e.offsetY) >
        2
      ) {
        this.isDragging = true;
      }
    },
    onMouseup() {
      this.mousedownFlag = false;
      this.isDragging = false;
    },
    onClickMap() {},
    onCopy: function() {
      alert(this.$t(`info_copied`));
    },
    onError: function() {}
  }
};
</script>

<style scoped>
.map-pos {
  position: absolute;
  right: 255px;
  top: 10px;
  font-size: 14px;
  color: #fff;
  user-select: none;
  text-align: right;
}
.map-title {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  color: #00ff00;
  width: 600px;
  height: 50px;
  text-align: left;
}
.map-title2 {
  position: absolute;
  top: 5px;
  left: 0%;
  transform: translateX(-50%);
  color: #00ff00;
  width: 600px;
  height: 50px;
  text-align: right;
}
.map-title-devrank {
  position: absolute;
  top: 80px;
  left: 255px;
  width: 800px;
  height: 50px;
  text-align: right;
}
.map-area {
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 822px;
  height: 843px;
  background-image: url("/img/frame_zone.png");
  overflow: none;
}
.map-scroll-stage {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 800px;
  overflow: none;
}
.minimap-area {
  position: absolute;
  top: 105px;
  right: calc(50% + 436px);
  width: 328px;
  height: 328px;
  background-image: url("/img/frame_world.png");
  overflow: none;
}
.minimap-title {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.minimap-scroll-stage {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 320px;
  height: 320px;
  overflow: none;
}
.land-info-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.land-info-area {
  position: absolute;
  top: 453px;
  left: calc(50% + 436px);
  width: 328px;
  height: 471px;
  overflow: none;
  background-image: url("/img/frame_field_info.png");
  padding: 10px;
}
.map-info-area {
  position: absolute;
  top: 480px;
  right: calc(50% + 436px);
  width: 328px;
  height: 442px;
  overflow: none;
  border: #000 solid 1px;
  background-image: url("/img/frame_field_info_m.png");
  background-size: 100% 100%;
  padding: 10px;
}
.gamemap-area {
  position: absolute;
  top: 83px;
  left: calc(50% + 436px);
  width: 328px;
  height: 349px;
  background-image: url("/img/frame_field.png");
  overflow: none;
}
.gamemap-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.gamemap-scroll-area {
  position: absolute;
  top: 25px;
  left: 4px;
  width: 320px;
  height: 320px;
  background-image: url("/img/map/map_01.png");
  overflow: none;
}
.map-area.dragging {
  cursor: move;
}
.map-selector {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 150px;
  font-size: 12px;
  user-select: none;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 3px;
  color: #000;
  border: 1px solid #000;
}
.map-selector ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.urban-list {
}
.urban-list .urban-item {
  position: relative;
}
.urban-list .urban-item > span {
  display: block;
  padding: 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;
}
.urban-list .urban-item:first-child > span {
  border-top: none;
}
.urban-list .urban-item::after {
  content: "+";
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 25px;
  color: #666;
}
.urban-list .urban-item.active::after {
  content: "-";
}
.map-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: #f0f0f0;
}
.map-list .map-item {
  display: none;
}
.map-list .map-item a {
  display: block;
  padding: 5px;
  border-top: 1px solid #ccc;
  font-size: 11px;
  color: #333;
  text-decoration: none;
  outline: none;
}
.map-list .map-item a:hover {
  background-color: #e5e5e5;
}
.map-list .map-item a::before {
  content: "-";
  display: inline-block;
  padding: 0 5px;
}
.map-list .map-item.active a {
  background-color: #e5e5e5;
}
.map-list .map-item.active a::before {
  content: ">>";
}
.urban-list .urban-item.active .map-item {
  display: block;
}
.map-list .map-item.active {
  display: block;
}
table,
th,
td {
  border: 0px solid white !important;
  min-width: 0px !important;
  min-height: 0px !important;
}
</style>